var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path10, _g9, _path11, _g10, _path12, _g11, _path13, _g12, _path14, _g13, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g14, _path22, _g15, _path23, _g16, _path24, _path25, _path26, _path27, _path28, _path29, _g17, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g18, _path41, _g19, _path42, _g20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0765 15.9826H21.793V14.6065H22.0599C22.5269 14.6065 23.1107 14.6398 23.1107 15.257C23.1107 15.8992 22.5686 15.9826 22.0765 15.9826ZM19.0491 13.9977H18.2651C17.698 13.2971 16.8807 12.8134 15.9383 12.5965H19.0491V13.9977ZM19.0491 15.5489H19.0157C18.899 15.0235 18.6738 14.5564 18.3819 14.1478H19.0491V15.5489ZM19.0491 18.6598H18.507C18.7655 18.2594 18.9574 17.8007 19.0491 17.2836V18.6598ZM19.0491 20.211H16.4053C17.2226 19.9441 17.9149 19.4687 18.3986 18.8099H19.0491V20.211ZM16.2802 18.8099L15.8799 19.2102L15.4796 18.8099L15.3294 18.6598L14.9374 18.2678L15.2627 17.9508C15.1126 17.9925 14.9541 18.0176 14.7873 18.0176C14.1868 18.0176 13.7198 17.7257 13.4863 17.2586H16.0884C16.055 17.317 16.0217 17.3754 15.9883 17.4338L16.8223 18.2678L16.3553 18.7348L16.2802 18.8099ZM13.1026 19.9274L12.0017 18.8266L12.0184 18.8099L12.1685 18.6598L13.1026 17.7257L14.2035 18.8266L13.1026 19.9274ZM11.9183 18.0342C11.9183 17.9592 11.9767 17.8925 12.0601 17.8925C12.1435 17.8925 12.2102 17.9592 12.2102 18.0342C12.2102 18.1176 12.1435 18.176 12.0601 18.176C11.9767 18.176 11.9183 18.1093 11.9183 18.0342ZM12.2102 17.4921C12.2102 17.5755 12.1435 17.6339 12.0601 17.6339C11.9767 17.6339 11.9183 17.5672 11.9183 17.4921C11.9183 17.4171 11.9767 17.3504 12.0601 17.3504C12.1435 17.3504 12.2102 17.4171 12.2102 17.4921ZM11.3596 17.2586L11.2094 17.1085L10.6507 16.5581L11.5097 15.7074L11.6431 15.5739L11.7766 15.7074L12.6272 16.5581L12.0768 17.1085L11.9267 17.2586L11.6431 17.5422L11.3596 17.2586ZM12.8524 16.9667C12.9358 16.9667 13.0026 17.0334 13.0026 17.1085C13.0026 17.1919 12.9358 17.2503 12.8524 17.2503C12.769 17.2503 12.7106 17.1836 12.7106 17.1085C12.7106 17.0334 12.769 16.9667 12.8524 16.9667ZM12.8524 16.433C12.9358 16.433 13.0026 16.4997 13.0026 16.5747C13.0026 16.6581 12.9358 16.7165 12.8524 16.7165C12.769 16.7165 12.7106 16.6498 12.7106 16.5747C12.7106 16.4913 12.769 16.433 12.8524 16.433ZM13.2861 15.3321C13.3695 15.3321 13.4362 15.3988 13.4362 15.4738C13.4362 15.4989 13.4279 15.5239 13.4112 15.5489C13.4029 15.5656 13.3862 15.5739 13.3779 15.5906C13.3695 15.5906 13.3695 15.5989 13.3612 15.5989C13.3528 15.5989 13.3528 15.6073 13.3445 15.6073C13.3362 15.6073 13.3362 15.6073 13.3278 15.6156C13.3278 15.6156 13.3278 15.6156 13.3195 15.6156C13.3111 15.6156 13.3111 15.6156 13.3028 15.6156C13.3028 15.6156 13.3028 15.6156 13.2945 15.6156C13.2861 15.6156 13.2861 15.6156 13.2778 15.6156C13.2694 15.6156 13.2694 15.6156 13.2611 15.6156C13.2611 15.6156 13.2611 15.6156 13.2528 15.6156C13.2444 15.6156 13.2444 15.6156 13.2361 15.6156C13.2361 15.6156 13.2361 15.6156 13.2277 15.6156C13.2194 15.6156 13.2194 15.6156 13.2111 15.6073C13.2027 15.6073 13.2027 15.5989 13.1944 15.5989C13.186 15.5989 13.186 15.5906 13.1777 15.5906C13.161 15.5823 13.1527 15.5656 13.1443 15.5489C13.1277 15.5239 13.1193 15.4989 13.1193 15.4738C13.136 15.3988 13.2027 15.3321 13.2861 15.3321ZM13.2861 14.79C13.3695 14.79 13.4362 14.8567 13.4362 14.9317C13.4362 15.0151 13.3695 15.0735 13.2861 15.0735C13.2027 15.0735 13.1443 15.0068 13.1443 14.9317C13.136 14.8567 13.2027 14.79 13.2861 14.79ZM15.4545 15.699L15.6047 15.5489H13.6364C13.8866 15.2236 14.2869 15.0151 14.7873 15.0151C15.1876 15.0151 15.5296 15.1569 15.7715 15.3821L16.497 14.6565L17.3978 15.5489L17.5479 15.699L17.5979 15.7491L16.497 16.85L16.2468 16.5998C16.2385 16.7832 16.2051 16.95 16.1468 17.1085H13.4112C13.3445 16.9334 13.3111 16.7415 13.3111 16.533C13.3111 16.2328 13.3862 15.9492 13.528 15.7074H15.4545V15.699ZM28.1064 16.4163C28.1064 15.5656 28.7986 14.89 29.6577 14.89C30.2999 14.89 30.8753 15.257 31.334 15.6823L31.2506 12.6966C30.6501 12.4881 29.9829 12.3713 29.3407 12.3713C27.7728 12.3713 26.4384 13.222 25.7462 14.4981C25.4042 13.1136 24.2033 12.4464 22.6604 12.4464H0.342324V12.5965H13.6364C12.694 12.8134 11.885 13.3054 11.3095 13.9977H0.333984V14.1478H11.1928C10.8925 14.5564 10.6757 15.0235 10.5589 15.5489H0.333984V15.699H10.5172C10.4672 15.9492 10.4421 16.2078 10.4421 16.483C10.4421 16.6998 10.4588 16.9 10.4838 17.1002H0.333984V17.2503H10.5172C10.609 17.7757 10.8008 18.2427 11.0677 18.6514H0.333984V18.8015H11.1677C11.6515 19.4604 12.3437 19.9358 13.161 20.2027H0.333984V20.3528H13.8949L13.4779 19.9358L14.5788 18.8349L15.6797 19.9358L15.2627 20.3528H15.8215H21.793V17.9675H23.2442C24.1282 17.9675 24.8288 17.6506 25.2791 17.1002C25.5627 19.0267 27.189 20.4529 29.2156 20.4529C29.7244 20.4529 30.7836 20.3611 31.2423 20.1443L31.3257 17.2169C30.867 17.6673 30.3499 17.9425 29.691 17.9425C28.8403 17.9508 28.1064 17.2836 28.1064 16.4163Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_601_6895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 11,
    width: 2,
    height: 3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87617 11.9986L1.35742 12.5178L1.87661 13.0366L2.39535 12.5174L1.87617 11.9986Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_601_6895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.86815 11.4788L2.91066 12.5213L1.86815 13.5554L0.833984 12.5213L1.86815 11.4788Z",
    fill: "url(#paint0_linear_601_6895)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_601_6895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 12,
    width: 2,
    height: 2
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90192 12.2395L3.38281 12.7583L3.90163 13.2774L4.42074 12.7586L3.90192 12.2395Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_601_6895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.90331 11.7207L4.93748 12.7549L3.90331 13.789L2.86914 12.7549L3.90331 11.7207Z",
    fill: "url(#paint1_linear_601_6895)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_601_6895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 13,
    width: 2,
    height: 2
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18708 13.6553L2.66797 14.1741L3.18679 14.6932L3.7059 14.1744L3.18708 13.6553Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_601_6895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.18456 13.1299L4.21873 14.1724L3.18456 15.2066L2.15039 14.1724L3.18456 13.1299Z",
    fill: "url(#paint2_linear_601_6895)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_601_6895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 16,
    width: 2,
    height: 2
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0131 16.7296L5.49414 17.2485L6.0131 17.7675L6.53207 17.2485L6.0131 16.7296Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_601_6895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.01268 16.2158L7.04685 17.25L6.01268 18.2842L4.97852 17.25L6.01268 16.2158Z",
    fill: "url(#paint3_linear_601_6895)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_601_6895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 15,
    width: 2,
    height: 2
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09318 15.0362L2.57422 15.5552L3.09318 16.0741L3.61215 15.5552L3.09318 15.0362Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_601_6895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.09472 14.5227L4.12888 15.5569L3.09472 16.591L2.06055 15.5569L3.09472 14.5227Z",
    fill: "url(#paint4_linear_601_6895)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_601_6895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 14,
    width: 2,
    height: 2
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36271 14.2022L3.84375 14.7212L4.36272 15.2402L4.88168 14.7212L4.36271 14.2022Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_601_6895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.36034 13.6807L5.39451 14.7232L4.36034 15.7573L3.32617 14.7232L4.36034 13.6807Z",
    fill: "url(#paint5_linear_601_6895)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_601_6895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 12,
    width: 2,
    height: 2
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79413 12.8363L5.27539 13.3555L5.79457 13.8742L6.31332 13.355L5.79413 12.8363Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_601_6895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.79589 12.3206L6.83006 13.3547L5.79589 14.3889L4.76172 13.3547L5.79589 12.3206Z",
    fill: "url(#paint6_linear_601_6895)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_601_6895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 17,
    width: 3,
    height: 3
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33613 17.2366L6.375 18.198L7.3364 19.1591L8.29753 18.1977L7.33613 17.2366Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_601_6895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33814 16.2742L9.25635 18.1924L7.33814 20.1106L5.41992 18.1924L7.33814 16.2742Z",
    fill: "url(#paint7_linear_601_6895)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_601_6895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 15,
    width: 2,
    height: 2
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75276 15.5767L4.05078 16.2783L4.75236 16.9803L5.45434 16.2787L4.75276 15.5767Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_601_6895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75465 14.873L6.15578 16.2742L4.75465 17.6753L3.35352 16.2742L4.75465 14.873Z",
    fill: "url(#paint8_linear_601_6895)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_601_6895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 12,
    width: 3,
    height: 2
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48717 12.3627L7.75 13.0999L8.48717 13.837L9.22433 13.0999L8.48717 12.3627Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_601_6895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48205 11.6208L9.96658 13.097L8.48205 14.5732L7.00586 13.097L8.48205 11.6208Z",
    fill: "url(#paint9_linear_601_6895)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_601_6895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 13,
    width: 3,
    height: 3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44985 13.5607L6.71289 14.2981L7.45026 15.0351L8.18722 14.2977L7.44985 13.5607Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_601_6895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.45471 12.8213L8.9309 14.2975L7.45471 15.7737L5.97852 14.2975L7.45471 12.8213Z",
    fill: "url(#paint10_linear_601_6895)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_601_6895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 12,
    width: 3,
    height: 3
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70703 13.6055L10.4493 14.3395L11.1832 13.6055L10.4493 12.8633L9.70703 13.6055Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_601_6895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4488 12.1211L11.925 13.6056L10.4488 15.0818L8.97266 13.6056L10.4488 12.1211Z",
    fill: "url(#paint11_linear_601_6895)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_601_6895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 11,
    width: 1,
    height: 2
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.51648 11.2162L2.08008 11.6526L2.51648 12.089L2.95288 11.6526L2.51648 11.2162Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_601_6895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.51776 10.7869L3.38513 11.6542L2.51776 12.5216L1.65039 11.6542L2.51776 10.7869Z",
    fill: "url(#paint12_linear_601_6895)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31046 15.1401C2.39386 15.1401 2.46058 15.2069 2.46058 15.2819C2.46058 15.3653 2.39386 15.432 2.31046 15.432C2.22705 15.432 2.16867 15.3653 2.16867 15.2819C2.16033 15.2069 2.22705 15.1401 2.31046 15.1401ZM2.31046 15.6906C2.39386 15.6906 2.46058 15.7573 2.46058 15.8407C2.46058 15.9241 2.39386 15.9825 2.31046 15.9825C2.22705 15.9825 2.16867 15.9158 2.16867 15.8407C2.16033 15.7573 2.22705 15.6906 2.31046 15.6906Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89444 16.0076C3.97784 16.0076 4.04456 16.0743 4.04456 16.1493C4.04456 16.2327 3.97784 16.2995 3.89444 16.2995C3.81104 16.2995 3.75266 16.2327 3.75266 16.1493C3.74432 16.0743 3.81104 16.0076 3.89444 16.0076ZM3.89444 16.5497C3.97784 16.5497 4.04456 16.6164 4.04456 16.6998C4.04456 16.7832 3.97784 16.8416 3.89444 16.8416C3.81104 16.8416 3.75266 16.7749 3.75266 16.6998C3.74432 16.6164 3.81104 16.5497 3.89444 16.5497Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59686 13.8811C6.68026 13.8811 6.74698 13.9478 6.74698 14.0229C6.74698 14.1063 6.68026 14.173 6.59686 14.173C6.51346 14.173 6.45508 14.1063 6.45508 14.0229C6.45508 13.9562 6.51346 13.8811 6.59686 13.8811ZM6.59686 14.4315C6.68026 14.4315 6.74698 14.4983 6.74698 14.5817C6.74698 14.6651 6.68026 14.7234 6.59686 14.7234C6.51346 14.7234 6.45508 14.6567 6.45508 14.5817C6.45508 14.4983 6.51346 14.4315 6.59686 14.4315Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6828 13.1636C9.7662 13.1636 9.83292 13.2303 9.83292 13.3054C9.83292 13.3888 9.7662 13.4555 9.6828 13.4555C9.5994 13.4555 9.54102 13.3888 9.54102 13.3054C9.54102 13.2303 9.5994 13.1636 9.6828 13.1636ZM9.6828 13.7057C9.7662 13.7057 9.83292 13.7724 9.83292 13.8558C9.83292 13.9392 9.7662 13.9976 9.6828 13.9976C9.5994 13.9976 9.54102 13.9309 9.54102 13.8558C9.54102 13.7724 9.5994 13.7057 9.6828 13.7057Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92303 14.2644C8.00643 14.2644 8.07315 14.3311 8.07315 14.4062C8.07315 14.4896 8.00643 14.5563 7.92303 14.5563C7.83963 14.5563 7.78125 14.4896 7.78125 14.4062C7.78125 14.3311 7.83963 14.2644 7.92303 14.2644ZM7.92303 14.8065C8.00643 14.8065 8.07315 14.8732 8.07315 14.9566C8.07315 15.04 8.00643 15.0984 7.92303 15.0984C7.83963 15.0984 7.78125 15.0317 7.78125 14.9566C7.78125 14.8732 7.83963 14.8065 7.92303 14.8065Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06366 15.2654C5.14706 15.2654 5.21378 15.3321 5.21378 15.4072C5.21378 15.4906 5.14706 15.5573 5.06366 15.5573C4.98026 15.5573 4.92188 15.4906 4.92188 15.4072C4.92188 15.3321 4.98026 15.2654 5.06366 15.2654ZM5.06366 15.8075C5.14706 15.8075 5.21378 15.8742 5.21378 15.9576C5.21378 16.041 5.14706 16.0994 5.06366 16.0994C4.98026 16.0994 4.92188 16.0327 4.92188 15.9576C4.92188 15.8742 4.98026 15.8075 5.06366 15.8075Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_601_6895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 14,
    width: 3,
    height: 3
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92074 15.9572C5.92074 15.8822 5.97912 15.8071 6.06252 15.8071C6.14592 15.8071 6.21264 15.8738 6.21264 15.9572C6.21264 16.0406 6.14592 16.099 6.06252 16.099C5.97912 16.099 5.92074 16.0323 5.92074 15.9572ZM5.92074 15.4068C5.92074 15.3317 5.97912 15.265 6.06252 15.265C6.14592 15.265 6.21264 15.3317 6.21264 15.4068C6.21264 15.4902 6.14592 15.5569 6.06252 15.5569C5.97912 15.5569 5.92074 15.4902 5.92074 15.4068ZM5.22852 15.7321L6.18762 16.6912L7.14673 15.7321L6.18762 14.7729L5.22852 15.7321Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_601_6895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.18775 13.8137L8.10596 15.7319L6.18775 17.6502L4.26953 15.7319L6.18775 13.8137Z",
    fill: "url(#paint13_linear_601_6895)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_601_6895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 15,
    width: 3,
    height: 3
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63896 16.4744C7.63896 16.3993 7.69734 16.3243 7.78075 16.3243C7.86415 16.3243 7.93087 16.391 7.93087 16.4744C7.93087 16.5578 7.86415 16.6162 7.78075 16.6162C7.70568 16.6162 7.63896 16.5494 7.63896 16.4744ZM7.63896 15.9239C7.63896 15.8489 7.69734 15.7822 7.78075 15.7822C7.86415 15.7822 7.93087 15.8489 7.93087 15.9239C7.93087 16.0073 7.86415 16.0741 7.78075 16.0741C7.70568 16.0741 7.63896 16.0073 7.63896 15.9239ZM6.95508 16.2909L7.91419 17.25L8.87329 16.2909L7.91419 15.3318L6.95508 16.2909Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_601_6895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91431 14.3726L9.83253 16.2991L7.91431 18.2173L5.99609 16.2991L7.91431 14.3726Z",
    fill: "url(#paint14_linear_601_6895)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_601_6895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 13,
    width: 3,
    height: 3
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07344 15.265C9.07344 15.19 9.13182 15.1149 9.21523 15.1149C9.29863 15.1149 9.36535 15.1816 9.36535 15.265C9.36535 15.3484 9.29863 15.4068 9.21523 15.4068C9.13182 15.4068 9.07344 15.3484 9.07344 15.265ZM9.07344 14.7229C9.07344 14.6479 9.13182 14.5812 9.21523 14.5812C9.29863 14.5812 9.36535 14.6479 9.36535 14.7229C9.36535 14.8063 9.29863 14.8731 9.21523 14.8731C9.13182 14.8647 9.07344 14.798 9.07344 14.7229ZM8.09766 14.748L9.05676 15.7071L10.0159 14.748L9.05676 13.7805L8.09766 14.748Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_601_6895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.05689 12.8213L10.9834 14.7478L9.05689 16.6661L7.13867 14.7478L9.05689 12.8213Z",
    fill: "url(#paint15_linear_601_6895)"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4608 16.124C11.5442 16.124 11.611 16.1907 11.611 16.2658C11.611 16.3492 11.5442 16.4159 11.4608 16.4159C11.3774 16.4159 11.3191 16.3492 11.3191 16.2658C11.3107 16.1907 11.3774 16.124 11.4608 16.124ZM11.4608 16.6661C11.5442 16.6661 11.611 16.7328 11.611 16.8162C11.611 16.8996 11.5442 16.958 11.4608 16.958C11.3774 16.958 11.3191 16.8913 11.3191 16.8162C11.3107 16.7412 11.3774 16.6661 11.4608 16.6661Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7519 18.4841C12.8353 18.4841 12.902 18.5509 12.902 18.6259C12.902 18.7093 12.8353 18.776 12.7519 18.776C12.6685 18.776 12.6101 18.7093 12.6101 18.6259C12.6017 18.5509 12.6685 18.4841 12.7519 18.4841ZM12.7519 19.0262C12.8353 19.0262 12.902 19.093 12.902 19.1764C12.902 19.2598 12.8353 19.3181 12.7519 19.3181C12.6685 19.3181 12.6101 19.2514 12.6101 19.1764C12.6017 19.1013 12.6685 19.0262 12.7519 19.0262Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6796 17.6919C15.763 17.6919 15.8297 17.7586 15.8297 17.8337C15.8297 17.9171 15.763 17.9838 15.6796 17.9838C15.5962 17.9838 15.5378 17.9171 15.5378 17.8337C15.5295 17.7586 15.5962 17.6919 15.6796 17.6919ZM15.6796 18.234C15.763 18.234 15.8297 18.3007 15.8297 18.3841C15.8297 18.4675 15.763 18.5259 15.6796 18.5259C15.5962 18.5259 15.5378 18.4592 15.5378 18.3841C15.5295 18.3091 15.5962 18.234 15.6796 18.234Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04608 13.0549C5.12948 13.0549 5.1962 13.1217 5.1962 13.1967C5.1962 13.2801 5.12948 13.3468 5.04608 13.3468C4.96268 13.3468 4.9043 13.2801 4.9043 13.1967C4.9043 13.1217 4.96268 13.0549 5.04608 13.0549ZM5.04608 13.6054C5.12948 13.6054 5.1962 13.6721 5.1962 13.7555C5.1962 13.8389 5.12948 13.8973 5.04608 13.8973C4.96268 13.8973 4.9043 13.8306 4.9043 13.7555C4.9043 13.6721 4.96268 13.6054 5.04608 13.6054Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59881 17.5332C7.68221 17.5332 7.74893 17.5999 7.74893 17.675C7.74893 17.7584 7.68221 17.8251 7.59881 17.8251C7.51541 17.8251 7.45703 17.7584 7.45703 17.675C7.45703 17.6083 7.51541 17.5332 7.59881 17.5332ZM7.59881 18.0836C7.68221 18.0836 7.74893 18.1504 7.74893 18.2338C7.74893 18.3172 7.68221 18.3756 7.59881 18.3756C7.51541 18.3756 7.45703 18.3088 7.45703 18.2338C7.45703 18.1504 7.51541 18.0836 7.59881 18.0836Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_601_6895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 17,
    width: 3,
    height: 2
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57377 18.0755C8.57377 18.0005 8.63215 17.9254 8.71555 17.9254C8.79895 17.9254 8.86567 17.9921 8.86567 18.0755C8.86567 18.1589 8.79895 18.2173 8.71555 18.2173C8.63215 18.2173 8.57377 18.1506 8.57377 18.0755ZM8.57377 17.5251C8.57377 17.45 8.63215 17.3833 8.71555 17.3833C8.79895 17.3833 8.86567 17.45 8.86567 17.5251C8.86567 17.6085 8.79895 17.6752 8.71555 17.6752C8.63215 17.6752 8.57377 17.6085 8.57377 17.5251ZM7.83984 17.9755L8.79895 18.9346L9.75806 17.9755L8.79895 17.0164L7.83984 17.9755Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_601_6895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.79908 16.0574L10.7173 17.9756L8.79908 19.8938L6.88086 17.9756L8.79908 16.0574Z",
    fill: "url(#paint16_linear_601_6895)"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8457 13.2469C6.8457 13.2052 6.87906 13.1719 6.92076 13.1719C6.96246 13.1719 6.99582 13.2052 6.99582 13.2469C6.99582 13.297 6.95412 13.3137 6.92076 13.3137C6.8874 13.3137 6.8457 13.297 6.8457 13.2469ZM6.8457 12.7799C6.8457 12.7382 6.87906 12.7048 6.92076 12.7048C6.96246 12.7048 6.99582 12.7382 6.99582 12.7799C6.99582 12.8299 6.95412 12.8466 6.92076 12.8466C6.8874 12.855 6.8457 12.8299 6.8457 12.7799Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69647 12.6296C7.77987 12.6296 7.84659 12.6964 7.84659 12.7714C7.84659 12.8548 7.77987 12.9215 7.69647 12.9215C7.61307 12.9215 7.55469 12.8548 7.55469 12.7714C7.55469 12.6964 7.61307 12.6296 7.69647 12.6296ZM7.69647 13.1717C7.77987 13.1717 7.84659 13.2385 7.84659 13.3219C7.84659 13.4053 7.77987 13.4636 7.69647 13.4636C7.61307 13.4636 7.55469 13.3969 7.55469 13.3219C7.55469 13.2385 7.61307 13.1717 7.69647 13.1717Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3457 17.4584C5.3457 17.4167 5.37906 17.375 5.42076 17.375C5.46246 17.375 5.50416 17.4083 5.50416 17.4584C5.50416 17.5084 5.45412 17.5334 5.42076 17.5334C5.3874 17.5418 5.3457 17.5167 5.3457 17.4584ZM5.3457 16.9496C5.3457 16.9079 5.37906 16.8662 5.42076 16.8662C5.46246 16.8662 5.50416 16.8996 5.50416 16.9496C5.50416 16.9997 5.45412 17.0247 5.42076 17.0247C5.3874 17.0247 5.3457 16.9997 5.3457 16.9496Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23819 17.9673C6.32159 17.9673 6.38831 18.034 6.38831 18.1091C6.38831 18.1925 6.32159 18.2592 6.23819 18.2592C6.15479 18.2592 6.09641 18.1925 6.09641 18.1091C6.08807 18.034 6.15479 17.9673 6.23819 17.9673ZM6.23819 18.5094C6.32159 18.5094 6.38831 18.5761 6.38831 18.6595C6.38831 18.7429 6.32159 18.8013 6.23819 18.8013C6.15479 18.8013 6.09641 18.7346 6.09641 18.6595C6.08807 18.5844 6.15479 18.5094 6.23819 18.5094Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27734 12.7711C3.27734 12.7294 3.3107 12.6877 3.3524 12.6877C3.3941 12.6877 3.43581 12.7211 3.43581 12.7711C3.43581 12.8211 3.38576 12.8462 3.3524 12.8462C3.32738 12.8545 3.27734 12.8295 3.27734 12.7711ZM3.27734 12.2624C3.27734 12.2207 3.3107 12.179 3.3524 12.179C3.3941 12.179 3.43581 12.2123 3.43581 12.2624C3.43581 12.3124 3.38576 12.3374 3.3524 12.3374C3.32738 12.3374 3.27734 12.3124 3.27734 12.2624Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89258 11.7537C1.89258 11.7203 1.9176 11.687 1.9593 11.687C2.001 11.687 2.02602 11.7203 2.02602 11.7537C2.02602 11.7954 1.98432 11.8121 1.9593 11.8121C1.93428 11.8121 1.89258 11.7954 1.89258 11.7537ZM1.89258 11.345C1.89258 11.3117 1.9176 11.2783 1.9593 11.2783C2.001 11.2783 2.02602 11.3117 2.02602 11.345C2.02602 11.3867 1.98432 11.4034 1.9593 11.4034C1.93428 11.4034 1.89258 11.3867 1.89258 11.345Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91797 14.3475C3.91797 14.3058 3.95133 14.2724 3.99303 14.2724C4.03473 14.2724 4.06809 14.3058 4.06809 14.3475C4.06809 14.3975 4.02639 14.4142 3.99303 14.4142C3.95967 14.4225 3.91797 14.3975 3.91797 14.3475ZM3.91797 13.8888C3.91797 13.8471 3.95133 13.8137 3.99303 13.8137C4.03473 13.8137 4.06809 13.8471 4.06809 13.8888C4.06809 13.9388 4.02639 13.9555 3.99303 13.9555C3.95967 13.9555 3.91797 13.9305 3.91797 13.8888Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M2.43359 14.3309C2.43359 14.2892 2.46695 14.2558 2.50865 14.2558C2.55035 14.2558 2.58371 14.2892 2.58371 14.3309C2.58371 14.3809 2.54201 14.3976 2.50865 14.3976C2.47529 14.3976 2.43359 14.3809 2.43359 14.3309ZM2.43359 13.8722C2.43359 13.8305 2.46695 13.7971 2.50865 13.7971C2.55035 13.7971 2.58371 13.8305 2.58371 13.8722C2.58371 13.9222 2.54201 13.9389 2.50865 13.9389C2.47529 13.9389 2.43359 13.9139 2.43359 13.8722Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2832 12.7796C1.2832 12.7379 1.31656 12.7046 1.34992 12.7046C1.39162 12.7046 1.42498 12.7379 1.42498 12.7796C1.42498 12.8297 1.38328 12.8463 1.34992 12.8463C1.3249 12.8547 1.2832 12.8297 1.2832 12.7796ZM1.2832 12.3209C1.2832 12.2792 1.31656 12.2458 1.34992 12.2458C1.39162 12.2458 1.42498 12.2792 1.42498 12.3209C1.42498 12.371 1.38328 12.3876 1.34992 12.3876C1.3249 12.3876 1.2832 12.3626 1.2832 12.3209Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1789 15.2732C16.2623 15.2732 16.329 15.3399 16.329 15.415C16.329 15.4984 16.2623 15.5651 16.1789 15.5651C16.0955 15.5651 16.0371 15.4984 16.0371 15.415C16.0371 15.3399 16.0955 15.2732 16.1789 15.2732ZM16.1789 15.8236C16.2623 15.8236 16.329 15.8904 16.329 15.9738C16.329 16.0572 16.2623 16.1155 16.1789 16.1155C16.0955 16.1155 16.0371 16.0488 16.0371 15.9738C16.0371 15.8904 16.0955 15.8236 16.1789 15.8236Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_601_6895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 15,
    width: 3,
    height: 3
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92516 16.5827C9.92516 16.5077 9.98354 16.4326 10.0669 16.4326C10.1503 16.4326 10.2171 16.4993 10.2171 16.5827C10.2171 16.6661 10.1503 16.7245 10.0669 16.7245C9.98354 16.7245 9.92516 16.6661 9.92516 16.5827ZM8.91602 16.7829L9.87512 17.742L10.8342 16.7829L10.2254 16.1741L9.92516 16.1991L9.87512 15.8154L8.91602 16.7829Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_601_6895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.87525 14.8647L11.7935 16.783L9.87525 18.7012L7.95703 16.783L9.87525 14.8647Z",
    fill: "url(#paint17_linear_601_6895)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_601_6895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 14,
    width: 2,
    height: 3
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92439 16.0408C9.92439 15.9658 9.98277 15.8991 10.0662 15.8991C10.1496 15.8991 10.2163 15.9658 10.2163 16.0408C10.2163 16.1242 10.1496 16.191 10.0662 16.191C9.98277 16.1826 9.92439 16.1159 9.92439 16.0408ZM9.39062 15.7323L10.1329 16.4745L10.8752 15.7323L10.1329 14.99L9.39062 15.7323Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_601_6895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1246 14.2561L11.6008 15.7323L10.1246 17.2085L8.64844 15.7323L10.1246 14.2561Z",
    fill: "url(#paint18_linear_601_6895)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_601_6895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 17,
    width: 3,
    height: 3
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5705 17.5415L9.60938 18.5029L10.5708 19.4641L11.5319 18.5027L10.5705 17.5415Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_601_6895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5667 16.583L12.4849 18.5096L10.5667 20.4278L8.64844 18.5096L10.5667 16.583Z",
    fill: "url(#paint19_linear_601_6895)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_601_6895",
    x1: 1.52824,
    y1: 12.1751,
    x2: 2.161,
    y2: 12.8078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377582,
    stopColor: "#000509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2833,
    stopColor: "#002541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#003D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#004F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#005AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_601_6895",
    x1: 3.5627,
    y1: 12.4143,
    x2: 4.19539,
    y2: 13.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377582,
    stopColor: "#000509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2833,
    stopColor: "#002541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#003D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#004F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#005AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_601_6895",
    x1: 2.84294,
    y1: 13.826,
    x2: 3.47572,
    y2: 14.4587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377582,
    stopColor: "#000509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2833,
    stopColor: "#002541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#003D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#004F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#005AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_601_6895",
    x1: 5.66778,
    y1: 16.9044,
    x2: 6.30065,
    y2: 17.5373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377582,
    stopColor: "#000509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2833,
    stopColor: "#002541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#003D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#004F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#005AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_601_6895",
    x1: 2.7489,
    y1: 15.214,
    x2: 3.38187,
    y2: 15.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377582,
    stopColor: "#000509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2833,
    stopColor: "#002541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#003D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#004F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#005AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_601_6895",
    x1: 4.01532,
    y1: 14.3769,
    x2: 4.6481,
    y2: 15.0097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377582,
    stopColor: "#000509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2833,
    stopColor: "#002541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#003D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#004F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#005AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_601_6895",
    x1: 5.45245,
    y1: 13.0119,
    x2: 6.08532,
    y2: 13.6448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377582,
    stopColor: "#000509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2833,
    stopColor: "#002541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#003D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#004F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#005AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_601_6895",
    x1: 6.77327,
    y1: 17.6291,
    x2: 7.94612,
    y2: 18.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377582,
    stopColor: "#000509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2833,
    stopColor: "#002541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#003D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#004F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#005AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_601_6895",
    x1: 4.30506,
    y1: 15.8228,
    x2: 5.1611,
    y2: 16.6788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377582,
    stopColor: "#000509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2833,
    stopColor: "#002541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#003D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#004F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#005AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_601_6895",
    x1: 8.06769,
    y1: 12.6864,
    x2: 8.97075,
    y2: 13.5895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377582,
    stopColor: "#000509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2833,
    stopColor: "#002541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#003D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#004F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#005AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_601_6895",
    x1: 7.03905,
    y1: 13.8807,
    x2: 7.94222,
    y2: 14.7839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377582,
    stopColor: "#000509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2833,
    stopColor: "#002541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#003D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#004F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#005AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_601_6895",
    x1: 9.97402,
    y1: 13.1344,
    x2: 10.9162,
    y2: 14.0765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377582,
    stopColor: "#000509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2833,
    stopColor: "#002541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#003D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#004F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#005AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_601_6895",
    x1: 2.27659,
    y1: 11.4171,
    x2: 2.8072,
    y2: 11.9477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377582,
    stopColor: "#000509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2833,
    stopColor: "#002541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#003D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#004F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#005AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_601_6895",
    x1: 5.50973,
    y1: 15.0453,
    x2: 6.87576,
    y2: 16.4113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377582,
    stopColor: "#000509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2833,
    stopColor: "#002541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#003D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#004F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#005AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_601_6895",
    x1: 7.23146,
    y1: 15.612,
    x2: 8.59764,
    y2: 16.9782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377582,
    stopColor: "#000509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2833,
    stopColor: "#002541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#003D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#004F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#005AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_601_6895",
    x1: 8.37676,
    y1: 14.0646,
    x2: 9.74273,
    y2: 15.4305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377582,
    stopColor: "#000509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2833,
    stopColor: "#002541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#003D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#004F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#005AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_601_6895",
    x1: 8.11761,
    y1: 17.2959,
    x2: 9.48378,
    y2: 18.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377582,
    stopColor: "#000509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2833,
    stopColor: "#002541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#003D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#004F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#005AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_601_6895",
    x1: 9.19455,
    y1: 16.104,
    x2: 10.5604,
    y2: 17.4699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377582,
    stopColor: "#000509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2833,
    stopColor: "#002541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#003D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#004F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#005AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_601_6895",
    x1: 9.55214,
    y1: 15.164,
    x2: 10.6976,
    y2: 16.3094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377582,
    stopColor: "#000509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2833,
    stopColor: "#002541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#003D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#004F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#005AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_601_6895",
    x1: 9.98889,
    y1: 17.9242,
    x2: 11.1515,
    y2: 19.0869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377582,
    stopColor: "#000509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2833,
    stopColor: "#002541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5108,
    stopColor: "#003D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    stopColor: "#004F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8832,
    stopColor: "#005AA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EA8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpc);
export default __webpack_public_path__ + "static/media/opc.17b9c31008858f77be61043b2aec0689.svg";
export { ForwardRef as ReactComponent };